import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/system';

import HookFormCheckboxField from 'reservations/form/components/HookFormCheckboxField';

const OptInTypography = styled(Typography)(({ theme }) => ({
  color: theme.palette.soy.main,
  fontSize: '12px'
})) as typeof Typography;

function MarketingOptIn() {
  return (
    <Box data-testid="opt-in-section">
      <OptInTypography>Receive rewards & offers by:</OptInTypography>
      <Grid container>
        <Grid item>
          <HookFormCheckboxField
            name="optInMarketingSms"
            Label={<OptInTypography>Text message</OptInTypography>}
          />
        </Grid>
        <Grid item>
          <HookFormCheckboxField
            name="optInMarketingEmail"
            Label={<OptInTypography>Email</OptInTypography>}
          />
        </Grid>
      </Grid>
      <OptInTypography>
        By checking the text message box, I consent to receive automated offers
        and reward messages at the number provided from the merchant and/or its
        partners and confirm that I agree with your Privacy Policy and Terms of
        Service. Consent is not a condition to purchase. Msg&Data rates may
        apply. Msg frequency varies. Text STOP/HELP at any time.
      </OptInTypography>
    </Box>
  );
}

export default MarketingOptIn;
